import ExamDetail from "@/controllers/exam/exam-detail.js";
import CONFIG from "@/assets/js/config.custom.js";

export default {
  extends: ExamDetail,
  data() {
    return {
      examTypeOptions: CONFIG.EXAM_TYPE,
    };
  },
  computed: {
    displayExamType() {
      const selected = this.examTypeOptions.find(
        (type) => type.id == this.examInfo.exam_type
      );
      return selected ? selected.text : this.examInfo.exam_type;
    },
  },
};
